// ---------------------------------------------------------------------------
// Customer-type → visible nav modules
// ---------------------------------------------------------------------------

export type NavSection =
  | 'orders'
  | 'billing'
  | 'pricing'
  | 'delivery'
  | 'help'
  | 'contracts'
  | 'bids'
  | 'future_prices'
  | 'price_watch'
  | 'school_compliance'
  | 'smart_reorder'
  | 'par_levels'
  | 'provisional_costs'
  | 'sustainability'
  | 'order_intake';

const CUSTOMER_MODULES: Record<string, NavSection[]> = {
  wholesale: [
    'orders', 'billing', 'pricing', 'delivery', 'help',
    'contracts', 'bids', 'future_prices', 'price_watch',
    'smart_reorder', 'par_levels', 'provisional_costs',
  ],
  retail: ['orders', 'billing', 'pricing', 'delivery', 'help'],
  restaurant: [
    'orders', 'billing', 'pricing', 'delivery', 'help',
    'smart_reorder', 'par_levels', 'sustainability',
  ],
  institution: [
    'orders', 'billing', 'pricing', 'delivery', 'help',
    'contracts', 'bids', 'smart_reorder', 'par_levels',
  ],
  broker: [
    'orders', 'billing', 'pricing', 'delivery', 'help',
    'contracts', 'bids', 'future_prices', 'price_watch', 'provisional_costs',
  ],
  school: [
    'orders', 'billing', 'pricing', 'delivery', 'help',
    'contracts', 'school_compliance', 'smart_reorder', 'par_levels',
  ],
};

const DEFAULT_MODULES: NavSection[] = [
  'orders', 'billing', 'pricing', 'delivery', 'help',
];

export function getVisibleModules(customerType: string): NavSection[] {
  return CUSTOMER_MODULES[customerType] ?? DEFAULT_MODULES;
}

export function canSee(customerType: string, section: NavSection): boolean {
  const modules = getVisibleModules(customerType);
  return modules.includes(section);
}
